/**
 * Shared utilities for Redux async thunk error handling.
 *
 * Extracts a human-readable error string from an Axios error (or any thrown
 * value) for use in rejectWithValue across the dashboard-cluster thunks.
 */

/**
 * Extract a serialisable error string from a caught Axios error.
 *
 * Prefers the backend response body, falls back to the JS Error message,
 * then to a generic sentinel.
 *
 * @param {unknown} e - caught error from an async thunk
 * @returns {string|object} serialisable error value for rejectWithValue
 */
export function extractThunkError(e) {
  return e?.response?.data ?? e?.message ?? 'Unknown error';
}
